import React, { useEffect } from 'react';
import { Box } from '@mui/material';

import HeaderProfile from '../../../components/header_Profile/header_Profile.index';
import NewPharmacyForm from './newPharmacy/NewPharmacyForm';

const NewPharmacyPage = () => {
  // Simple mount log to check how often this page (and thus HeaderProfile) renders.
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log('[NewPharmacyPage] mounted');
  }, []);

  return (
    <>
      {/* NOTE:
         * If HeaderProfile does API calls on mount, they will run every time this page
         * is navigated to. To improve "time to first paint", consider:
         *  - memoizing HeaderProfile if its props are stable
         *  - using a Suspense boundary with a lightweight fallback
         *  - caching its data with TanStack Query so re-renders are instant
         */}
      <HeaderProfile />

      {/* wrapper with horizontal margin */}
      <Box sx={{ mx: 2, mt: 2 }}>

        <NewPharmacyForm />
      </Box>
    </>
  );
};

export default NewPharmacyPage;
